// src/sync/apiTrace.js
// v3.2.08: buffer circular local para diagnosticar primeira chamada 429.
// Não envia nada ao servidor. 100 eventos máx em localStorage.

const TRACE_KEY = "fz:apiTrace:v1";
const TRACE_MAX = 100;
let memoryBuffer = null;

function readBuffer() {
  if (memoryBuffer !== null) return memoryBuffer;
  try {
    const raw = typeof localStorage !== "undefined"
      ? localStorage.getItem(TRACE_KEY) : null;
    const parsed = raw ? JSON.parse(raw) : [];
    memoryBuffer = Array.isArray(parsed) ? parsed : [];
  } catch (e) { memoryBuffer = []; }
  return memoryBuffer;
}

function writeBuffer(items) {
  memoryBuffer = items;
  try {
    if (typeof localStorage !== "undefined")
      localStorage.setItem(TRACE_KEY, JSON.stringify(items));
  } catch (e) {}
}

function safePath(url) {
  try {
    const u = new URL(
      String(url || ""),
      typeof window !== "undefined" ? window.location.origin : "http://x"
    );
    return u.pathname + (u.search ? u.search.slice(0, 40) : "");
  } catch (e) { return String(url || "").slice(0, 120); }
}

export function recordApiCall(entry) {
  try {
    const item = {
      at: new Date().toISOString(),
      ts: Date.now(),
      url: safePath(entry?.url || ""),
      action: String(entry?.action || "").slice(0, 80),
      collection: String(entry?.collection || "").slice(0, 80), // v3.2.11
      source: String(entry?.source || "").slice(0, 80),
      status: Number(entry?.status || 0),
      durMs: Number(entry?.durMs || 0),
      result: String(entry?.result || "ok").slice(0, 40),
    };
    const buffer = readBuffer();
    buffer.push(item);
    if (buffer.length > TRACE_MAX) buffer.splice(0, buffer.length - TRACE_MAX);
    writeBuffer(buffer);
    if (item.result === "real_429" || item.result === "local_backoff") {
      try {
        console.warn(
          `[apiTrace] ${item.result} | ${item.url} | action=${item.action}` +
          ` | source=${item.source} | ${item.durMs}ms`
        );
      } catch (_) {}
    }
  } catch (e) {}
}

export function getApiTrace() { return readBuffer().slice(); }
export function clearApiTrace() { writeBuffer([]); }

export function getApiTraceSummary() {
  const items = readBuffer();
  const byEndpoint = {};
  const byResult = {};
  let firstReal429 = null;
  let firstLocalBackoff = null;
  for (const item of items) {
    const key = `${item.url}${item.action ? ` [${item.action}]` : ""}${item.collection ? ` ${item.collection}` : ""}`;
    if (!byEndpoint[key]) {
      byEndpoint[key] = { count: 0, real_429: 0, local_backoff: 0, ok: 0,
        other: 0, sources: [] };
    }
    byEndpoint[key].count += 1;
    if (item.result === "real_429") byEndpoint[key].real_429 += 1;
    else if (item.result === "local_backoff") byEndpoint[key].local_backoff += 1;
    else if (item.result === "ok") byEndpoint[key].ok += 1;
    else byEndpoint[key].other += 1;
    if (!byEndpoint[key].sources.includes(item.source))
      byEndpoint[key].sources.push(item.source);
    byResult[item.result] = (byResult[item.result] || 0) + 1;
    if (!firstReal429 && item.result === "real_429") firstReal429 = item;
    if (!firstLocalBackoff && item.result === "local_backoff") firstLocalBackoff = item;
  }
  return { total: items.length, byResult, byEndpoint,
           firstReal429, firstLocalBackoff };
}

export function exportApiTraceJson() {
  return JSON.stringify({
    exportedAt: new Date().toISOString(),
    summary: getApiTraceSummary(),
    items: getApiTrace(),
  }, null, 2);
}

export async function traceAndFetch(url, init, traceOptions) {
  const source = String(traceOptions?.source || "");
  const action = String(traceOptions?.action || "");
  const collection = String(traceOptions?.collection || "");
  const startedAt = Date.now();
  try {
    const response = await fetch(url, init);
    try {
      recordApiCall({
        url: String(url || ""), action, collection, source,
        status: response.status, durMs: Date.now() - startedAt,
        result: response.status === 429 ? "real_429"
          : response.status === 503 ? "real_503"
          : (response.ok ? "ok" : "error"),
      });
    } catch (_) {}
    return response;
  } catch (err) {
    try {
      const msg = String(err?.message || "");
      recordApiCall({
        url: String(url || ""), action, collection, source, status: 0,
        durMs: Date.now() - startedAt,
        result: (msg.includes("timeout") || err?.name === "TimeoutError")
          ? "timeout" : err?.name === "AbortError" ? "abort" : "network_error",
      });
    } catch (_) {}
    throw err;
  }
}
